import type { SfccIntegrationConfig } from '@entities/platform-entities/integration/sfcc-integration-config.interface';

import { isValidSfccRelativePath } from './is-valid-sfcc-relative-path';
import { isValidSfccScapiHost } from './is-valid-sfcc-scapi-host';

const REQUIRED_FIELDS: {
  key: keyof SfccIntegrationConfig;
  label: string;
}[] = [
  { key: 'scapiHost', label: 'SCAPI host' },
  { key: 'organizationId', label: 'Organization ID' },
  { key: 'siteId', label: 'Site ID' },
  { key: 'locale', label: 'Locale' },
  { key: 'slasClientId', label: 'SLAS client ID' },
  { key: 'slasClientSecret', label: 'SLAS client secret' },
];

const RELATIVE_PATH_FIELDS: {
  key: keyof SfccIntegrationConfig;
  label: string;
}[] = [
  { key: 'cartAddPath', label: 'Cart add path' },
  { key: 'cartUpdatePath', label: 'Cart update path' },
  { key: 'cartRemovePath', label: 'Cart remove path' },
];

export function validateSfccIntegrationConfig(config?: SfccIntegrationConfig): string[] {
  const requiredErrors = REQUIRED_FIELDS.flatMap(({ key, label }) =>
    isNonEmptyString(config?.[key]) ? [] : [`${label} is required.`]
  );
  if (requiredErrors.length > 0) {
    return requiredErrors;
  }

  const errors: string[] = [];
  if (!isValidSfccScapiHost(config!.scapiHost)) {
    errors.push(
      'SCAPI host must be a trusted HTTPS *.api.commercecloud.salesforce.com origin without a path or query.'
    );
  }

  for (const { key, label } of RELATIVE_PATH_FIELDS) {
    const path = config![key];
    if (typeof path === 'string' && !isValidSfccRelativePath(path)) {
      errors.push(`${label} must be a same-origin relative path.`);
    }
  }

  return errors;
}

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}
